module.exports = __webpack_public_path__ + "static/img/loading.c7e2d405.gif";